<script context="module">
    // retain module scoped expansion state for each tree node
    const _expansionState = {
        /* treeNodeId: expanded <boolean> */
    }
</script>
<script>
    //	import { slide } from 'svelte/transition'
    export let category = {}
    export let top = false;
    const {name, categories, activate} = category

    function findChildrenActivate(categories) {
        if (categories) {
            for (const child of categories) {
                if (child.activate) {
                    return true;
                }

                if (findChildrenActivate(child.categories)) {
                    return true;
                }
            }
        }
        return false;
    }

    let expanded = _expansionState[name] || findChildrenActivate(categories)
    const toggleExpansion = () => {
        expanded = _expansionState[name] = !expanded
    }
    $: arrowDown = expanded
    $: hilight = activate ?? false;
    $: no_border = top;
</script>

<ul class="tree-view" class:no_border><!-- transition:slide -->
    <li class="nasted" class:hilight class:no_border>
        {#if categories}
			<span on:click={toggleExpansion}>
				<span class="arrow" class:arrowDown>&#x25b6</span>
                <strong>{name}</strong>
			</span>
            {#if expanded}
                {#each categories as category}
                    <svelte:self {category} />
                {/each}
            {/if}
        {:else}
			<span>
				<span class="no-arrow"/>
                <a href="{category.link}#linking">{name}</a>
			</span>
        {/if}
    </li>
</ul>

